// extracted by css-extract-rspack-plugin
export default {"sectionLabel":"uHUQM9oa9QYRUqBm"};